module.exports = __webpack_public_path__ + "img/gettedticket2.23874aa3.png";